// extracted by mini-css-extract-plugin
export default {"container":"ReviewAndEdit_container__S5vSF"};